module.exports = __webpack_public_path__ + "media/omega.25898a23.wav";